@use "sass:math";
@import "../../helpers/helpers";

.dropzoneObject {
  height: 0;
}

.dropzoneClickable {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 1.4;
  font-size: 42px;
  cursor: pointer;
  height: 56px;
  margin: 7px 14px;

  &:hover {
    opacity: 0.5;
  }

  & > * {
    display: none;
  }

  & > svg {
    display: block;
    pointer-events: none;
  }
}

.dragging {
  border: 3px dashed black;
}

// @keyframes dragging {
//   0% { opacity: 1; }
//   50% { opacity: 0.6; }
//   100% { opacity: 1; }
// }

.added {
  // background: magenta;
}

.uploading {
  // background: purple;
}

.error {
  background: red;
}

.success {
  @include loading;
}

.processed {
  // background: green;
}

.items > div,
.archivedItems > div {
  display: flex;
  flex-wrap: wrap;
}

.item {
  margin: math.div($gridPadding, 2);
  width: calc(33.33% - 0.9em);
  min-height: 93px;
  max-height: 120px;
  border: 0;
  cursor: grab;
  position: relative;

  &:hover {
    z-index: 1;
  }

  .zoom0 & {
    width: calc(50% - 0.9em);
    max-height: none;
    min-height: 0;
    height: 181px;
  }

  .zoom2 & {
    width: calc(20% - 0.9em);
    max-height: none;
    min-height: 0;
    height: 78px;
  }

  .zoom3 & {
    width: calc(16.66% - 0.9em);
    max-height: none;
    min-height: 0;
    height: 64px;
  }

  @include mq($until: iphone6plus) {
    width: calc(50% - 14px);
    height: 95px;
    // min-height: 93px;
  }

  &.archivedItemSelected {
    outline: 3px solid gray;
    outline-offset: 2px;
  }
}

.isFullscreen {
  .items {
    position: fixed;
    top: 15px;
    left: 15px;
    z-index: 20;
    box-shadow: 0px 0px 21px black;
    width: calc(100vw - 30px);
    height: calc(100vh - 30px);
    overflow: auto;
    background: $inputBackground;
    border-radius: 0.25em;

    & > div {
      width: calc(100% - 28px);
      margin: 0 auto;
      padding: 14px 0 30px;
      display: grid;
      grid-template-columns: repeat(auto-fill, 160px);
      grid-gap: $gridPadding;
      justify-content: space-between;
    }
  }

  .item {
    margin: 0;
    width: 100%;
    max-height: none;
    height: 120px;
  }

  .image {
    width: 100%;
    height: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  &.zoom0 {
    .items > div {
      grid-template-columns: repeat(auto-fill, 252px);
    }

    .item {
      height: 180px;
    }
  }

  &.zoom2 {
    .items > div {
      grid-template-columns: repeat(auto-fill, 120px);
    }

    .item {
      height: 90px;
    }
  }

  &.zoom3 {
    .items > div {
      grid-template-columns: repeat(auto-fill, 80px);
    }

    .item {
      height: 60px;
    }
  }
}

.isPrimary {
  border: 2px solid #f0f000;
}

.isWorkImage img {
  opacity: 0.6;
}

:global .sortable-selected {
  outline: 3px solid gray;
  outline-offset: 2px;
}

.progress {
  height: 100%;
  width: 100%;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  background: #aaa;
  transition: 0.2s width;
}

.image {
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    pointer-events: none;
  }
}

.details {
  padding: 0;
  opacity: 1;
  padding: 0 3px;
  display: none;
  z-index: 185;
  pointer-events: none;
  position: absolute;
  top: calc(100% + 8px);
  left: 0;

  .item:hover & {
    display: block;
  }

  .filename {
    // color: #b94a48;
    white-space: normal;
    // white-space: nowrap;
    width: 215px;
    line-height: 1.5;
    word-break: break-word;

    // .item:nth-child(3n) & {
    //   white-space: normal;
    // }

    .error & {
      font-size: 80%;
      margin-top: -100px;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
    }

    .filenameArea {
      padding: 6px;
      border: none;
      background: white;

      .error & {
        background: red;
      }
    }
  }
}

.archivedItems {
  user-select: none;

  .item {
    cursor: pointer;
  }
}

.x {
  position: absolute;
  width: 14px;
  height: 14px;
  display: none;
  padding: 5px;
  top: 7px;
  right: 7px;
  cursor: pointer;
  // background: url(remove.svg);
  background: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4IDgiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+Y2xvc2U8L3RpdGxlPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSI3IiBoZWlnaHQ9IjciLz48cGF0aCBkPSJNOCwwLDcuOTkzLDcuOTkzMDYsMCw4Vi4wMTQ4NlpNNy40MjE1Mi41ODM2Ny41ODYuNTk3NTVsLjAwNyw2LjgxMTg0LDYuODQyNTQtLjAwNjk0Wm0tMS4xOTk3NS42ODE3OC41MTQuNTIwMjVMNC41MjE1OSwzLjk2NDgybDIuMjUsMi4yMjE3My0uNTM1NjguNTIwMjVMMy45Nzg4NSw0LjQ5MiwxLjc0Myw2LjcxMzc0LDEuMjIxNCw2LjE4NjU1LDMuNDU3MjcsMy45Nzg2OSwxLjIyODk1LDEuNzkyNjRsLjUyODEzLS41MjcxOUwzLjk5MywzLjQ4MDI0WiIvPjwvc3ZnPg==");
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: center;

  .item:hover & {
    display: block;
  }
}

.averageImageSize {
  padding: 10px $gridPadding 16px;
  position: relative;

  @include mq($until: tablet) {
    padding: 10px 0 16px;
  }
}